// extracted by mini-css-extract-plugin
export default {"root":"EditModal_root__5QQaK","container":"EditModal_container__bQ+ej"};